import {ReactElement} from 'react';
import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import Text from '@frontend/ui-kit/Components/Text';
import './index.scss';

type Props = {
    title: string,
    text: string[],
    image: string,
    className: string
};

const Benefit = ({title, text, image, className}: Props): ReactElement => {
    const getText = text => (
        <Text className='product-info-benefit__text'>
            {text}
        </Text>
    );

    return (
        <div className={`product-info-benefit ${className}`}>
            <div className='product-info-benefit__image'>
                <img src={image} alt='product-info-benefit'/>
            </div>

            <Heading type={HEADING_TYPES['4']} className='product-info-benefit__title'>
                {title}
            </Heading>

            <div className='product-info-benefit__text'>
                {text.map(getText)}
            </div>
        </div>
    );
};

export {Benefit as TestableBenefit};
export default Benefit;
